import "./polyfills";
import "./assets/base.scss";
import Pusher from "pusher-js";
import Main from "./pages/Main";
import ReactDOM from "react-dom";
import Geocode from "react-geocode";
import {Provider} from "react-redux";
import "react-web-vector-icons/fonts";
import React, {Component} from "react";
import {loadUser} from "./actions/auth";
import {PusherProvider} from "react-pusher-hoc";
import {consts} from "./assets/values/constants";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./config/configureStore";
import {getNotification} from "./actions/notification";
import {BrowserRouter as Router} from "react-router-dom";

Geocode.setApiKey(consts.GOOGLE_API_KEY);
Geocode.enableDebug();

const store = configureStore();
const rootElement = document.getElementById("root");

const pusherClient = new Pusher("ff8dc06ce53831298a33", {
    cluster: "eu",
});

const renderApp = (Component) => {
    store.dispatch(loadUser());
    store.dispatch(getNotification());
    ReactDOM.render(
        <Provider store={store}>
            <PusherProvider value={pusherClient}>
                <Router>
                    <Component/>
                </Router>
            </PusherProvider>
        </Provider>,
        rootElement
    );
};

renderApp(Main);

if (module.hot) {
    module.hot.accept("./pages/Main", () => {
        const NextApp = require("./pages/Main").default;
        renderApp(NextApp);
    });
}

serviceWorker.unregister();
